import React from 'react';
import PlatformModalLayer from './PlatformModalLayer';
import { Ripple } from './PopupRipple.jsx';

export function ConfirmationHeroCard({
  icon,
  title,
  message,
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
  cancelButtonProps = {},
  confirmButtonProps = {},
  variant = 'success',
}) {
  return (
    <div className={`card popup-hero--${variant}`}>
      <div className="popup-hero">
        {icon ? (
          <div className="popup-hero-icon popup-hero-icon--ring" aria-hidden="true">
            {icon}
          </div>
        ) : null}
        {title ? <h2 className="popup-hero-title">{title}</h2> : null}
        {message ? <p className="popup-hero-message">{message}</p> : null}
      </div>
      <div className="row-scss popup-hero-actions">
        <button
          type="button"
          className="popup-hero-btn popup-hero-btn--cancel"
          onClick={onCancel}
          style={{
            position: 'relative',
            overflow: 'hidden',
            isolation: 'isolate',
          }}
          {...cancelButtonProps}
        >
          <Ripple />
          {cancelLabel}
        </button>
        <button
          type="button"
          className="popup-hero-btn popup-hero-btn--confirm"
          onClick={onConfirm}
          style={{
            position: 'relative',
            overflow: 'hidden',
            isolation: 'isolate',
          }}
          {...confirmButtonProps}
        >
          <Ripple />
          {confirmLabel}
        </button>
      </div>
    </div>
  );
}

export default function ConfirmationHeroModal({
  role,
  layerClassName = 'confirm-box confirm-box--hero',
  ...cardProps
}) {
  return (
    <PlatformModalLayer className={layerClassName} role={role} aria-label={cardProps.title} onDismiss={cardProps.onCancel}>
      <ConfirmationHeroCard {...cardProps} />
    </PlatformModalLayer>
  );
}
